module.exports = __webpack_public_path__ + "img/V01.43487d2a.jpg";